import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import MapTextField from 'components/Global/MapTextField';
import { Remove as RemoveIcon, Add as AddIcon } from '@material-ui/icons';
import {
    BASIC,
    ADVANCED,
    searchDocTypeEnum,
} from 'hooks/search/searchData';
import CustomButton from 'components/CustomInput/Button/index';
import {
    UPDATE_SEARCH_CONDITIONS,
    SET_SEARCH_DATA,
} from 'store/key';
import { APPLICANT } from 'utility/lookup';

export default function SearchCriteria({
    classes,
    searchData,
    formValid,
    defaultFormData,
    basicFormData,
    advancedFormData,
}) {
    const dispatch = useDispatch();

    const {
        forceErrorDisplay, searchType
    } = searchData;

    const userInfo = useSelector((state) => state.user);
    const isApplicant = userInfo?.role === APPLICANT;

    // const [searchType, setSearchType] = useState(BASIC); // or advanced
    const showAdvancedSearch = searchType === ADVANCED;
    const searchDocType = basicFormData.documentType.value;

    const setSearchType = (searchType) => {
        dispatch({
            type: SET_SEARCH_DATA,
            payload: {
                searchType: searchType,
            },
        });
    }

    useEffect(() => {
        dispatch({
            type: SET_SEARCH_DATA,
            payload: {
                isApplication: searchDocType === searchDocTypeEnum.INIT_APPLICATION,
            }
        });
        // eslint-disable-next-line
    }, [searchDocType]);

    const changeDataValid = (item, valid) => {
        formValid.current[item.name] = valid;
    };

    const changeSearchType = (e) => {
        setSearchType(searchType === BASIC ? ADVANCED : BASIC);
    };

    const handleFormData = (e, groupType) => {
        defaultFormData[groupType].setFormData(e);

        /** update search conditions */
        const {value, name} = e.target;
        const data = defaultFormData[groupType].formData[name];
        const searchItem = {
            fieldName: data.fieldName,
            fieldValue: value,
            operatorType: data.operatorType,
        };
        if (data.type === 'date') {
            searchItem.valueType = 'DATE';
            searchItem.fieldValue = new Date(value);
        } else if (data.isBoolean) {
            searchItem.valueType = 'BOOL';
        }
        dispatch({
            type: UPDATE_SEARCH_CONDITIONS,
            payload: {
                type: ['', undefined, null].includes(value) ? 'delete' : 'add',
                searchItem: searchItem,
            }
        });
    };
    return (
        <div className={'smaller'}>
            <Grid className={classes.criteriaContent}>
                <Grid container justify="flex-start">
                    <Grid container>
                        <Typography color="primary" className={classes.basicTitle}>
                            Basic Search
                        </Typography>
                    </Grid>
                    {Object.keys(basicFormData).length &&
                        Object.keys(basicFormData).map((i) => {
                            const item = basicFormData[i];
                            return item.hideInApplicant && isApplicant ? null : (
                                <Grid
                                    key={item.name}
                                    container
                                    item
                                    xs={3}
                                    wrap="nowrap"
                                    alignItems="baseline"
                                    className={classes.item}
                                >
                                    <Grid container item xs={11} wrap="nowrap">
                                        <MapTextField
                                            item={item}
                                            handleFormData={(e) => handleFormData(e, item.groupType)}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isValidValue={valid => changeDataValid(item, valid)}
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })}
                </Grid>
                <Grid container justify="flex-start">
                    <Grid container className={classes.advancedTitle}>
                        <CustomButton variant="outlined" onClick={changeSearchType}>
                            {searchType === ADVANCED ? <RemoveIcon /> : <AddIcon />}
                            Advanced Search
                        </CustomButton>
                    </Grid>
                    {showAdvancedSearch &&
                        Object.keys(advancedFormData).length &&
                        Object.keys(advancedFormData).map((i) => {
                            const item = advancedFormData[i];
                            let dateObj = {};
                            if (item.type === 'date') {
                                item.maxDateField && advancedFormData[item.maxDateField]?.value && (dateObj.maxDate = advancedFormData[item.maxDateField]?.value)
                                item.minDateField && advancedFormData[item.minDateField]?.value && (dateObj.minDate = advancedFormData[item.minDateField]?.value)
                            }
                            return item.hideInApplicant && isApplicant ? null : (
                                <Grid
                                    key={item.name}
                                    container
                                    item
                                    xs={3}
                                    wrap="nowrap"
                                    alignItems="baseline"
                                    className={classes.item}
                                >
                                    <Grid container item xs={11} wrap="nowrap">
                                        <MapTextField
                                            item={item}
                                            handleFormData={(e) => handleFormData(e, item.groupType)}
                                            {...dateObj}
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })}
                </Grid>
            </Grid>
        </div>
    );
};
